import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { feedbackModule } from '@/components/feedback/feedback.module';
import { patentsListModule } from '@/views/side-function-bar/patents-list/patents-list.module';
import { freeViewLimitModule } from '@/components/no-permission/free-view-limit.module';
import { commentDialogModule } from '@/components/dialog/CommentDialog/comment-dialog.module';
import { chemicalEntryModule } from '@/components/chemical/chemical-entry.module';
import { domNodesTipModule } from '@/components/dom-nodes-tip/dom-nodes-tip.module';

export const componentsModule = new ContainerModule((bind) => {
    feedbackModule(bind);
    patentsListModule(bind);
    freeViewLimitModule(bind);
    commentDialogModule(bind);
    chemicalEntryModule(bind);
    domNodesTipModule(bind);
});
